document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[data-thumb-target]');
  if (trigger) {
    const target = document.querySelector(trigger.getAttribute('data-thumb-target'));
    const img = trigger.querySelector('img');
    if (target && img) {
      target.src = img.dataset.full || img.src;
      target.srcset = img.dataset.fullset || '';
      target.alt = img.alt || '';
    }
    return;
  }

  if (event.target.closest('[data-popup-close]')) {
    dismissPopup();
    return;
  }

  const prev = event.target.closest('[data-carousel-prev]');
  const next = event.target.closest('[data-carousel-next]');
  if (prev || next) {
    const targetId = (prev || next).getAttribute(prev ? 'data-carousel-prev' : 'data-carousel-next');
    const scroller = document.getElementById(targetId);
    if (!scroller) return;
    const firstCard = scroller.querySelector('.product-carousel__item');
    const gap = 18;
    const step = firstCard ? firstCard.getBoundingClientRect().width + gap : scroller.clientWidth * 0.9;
    scroller.scrollBy({ left: prev ? -step : step, behavior: 'smooth' });
  }
});

const popupRoot = document.querySelector('[data-popup-root]');
const popupStorageKey = 'apex_discount_popup_closed';

function dismissPopup() {
  if (!popupRoot) return;
  popupRoot.setAttribute('hidden', 'hidden');
  try {
    localStorage.setItem(popupStorageKey, '1');
  } catch (e) {}
}

function showPopup() {
  if (!popupRoot) return;
  try {
    if (localStorage.getItem(popupStorageKey) === '1') return;
  } catch (e) {}

  window.setTimeout(function () {
    popupRoot.removeAttribute('hidden');
  }, 1400);
}

window.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') dismissPopup();
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', showPopup);
} else {
  showPopup();
}

/* v15: homepage slideshow + subtle parallax */
(function () {
  const slides = Array.from(document.querySelectorAll('[data-hero-slideshow] .hero-slide'));
  const realSlides = slides.filter(function (slide) { return !slide.classList.contains('hero-slide--fallback'); });
  if (realSlides.length > 1) {
    let index = 0;
    window.setInterval(function () {
      realSlides[index].classList.remove('is-active');
      index = (index + 1) % realSlides.length;
      realSlides[index].classList.add('is-active');
    }, 4200);
  }

  const layers = Array.from(document.querySelectorAll('[data-parallax-layer]'));
  if (!layers.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let ticking = false;
  function updateParallax() {
    const center = window.innerHeight / 2;
    layers.forEach(function (layer) {
      const rect = layer.getBoundingClientRect();
      const speed = parseFloat(layer.getAttribute('data-parallax-speed') || '0.12');
      const offset = (rect.top + rect.height / 2 - center) * speed;
      layer.style.transform = 'translate3d(0,' + (-offset).toFixed(2) + 'px,0)';
    });
    ticking = false;
  }
  function requestParallax() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateParallax);
  }
  window.addEventListener('scroll', requestParallax, { passive: true });
  window.addEventListener('resize', requestParallax);
  requestParallax();
})();
